<template>
  <div class="product-description" v-if="orderId">
    <el-tabs
      v-model="activeName"
      type="border-card"
      @tab-click="activeNameChange"
    >
      <el-tab-pane
        :label="$lange == 'en' ? 'Service request' : '请求详情'"
        name="description"
      >
        <!-- <OrderComponent
          @changeActiveName="changeActiveName"
          :fileData="fileData"
          v-if="showOrderFlag"
          :orderIdV2="orderIdV2"
          :isHandleV2="isHandleV2"
          :isDialog="isDialog"
        ></OrderComponent> -->
        <OrderComponentV2
          @changeActiveName="changeActiveName"
          :fileData="fileData"
          v-if="showOrderFlag"
          :orderIdV2="orderIdV2"
          :isDialog="isDialog"
        ></OrderComponentV2>
        <!-- <OrderComponentV2
          @changeActiveName="changeActiveName"
          :fileData="fileData"
          v-if="showOrderFlag"
          :orderId="orderIdV2"
        ></OrderComponentV2> -->
      </el-tab-pane>
      <el-tab-pane
        :label="$lange == 'en' ? 'Status recording' : '处理记录'"
        name="record"
      >
        <div class="record-lists">
          <div class="center-border"></div>
          <div class="list flex-between" v-for="(item,index) in recordData" :key="index">
            <div class="left">
              <p class="left-date">
                {{ moment(item.createTime).format("YYYY-MM-DD") }}
              </p>
              <p class="left-time">
                {{ moment(item.createTime).format("HH:mm:ss") }}
              </p>
            </div>
            <div class="right">
              <p class="user-name">
                {{ logText(item) }}
                <!-- <template v-if="item.objType === 3 || item.objType === 9">{{
                  item.handlerName
                }}</template>

                <template v-if="item.objType === 0">{{
                  item.additionalData.userName
                }}</template>

                <template v-if="item.objType === 18"></template>

                {{ `${userData[item.objType]}` }}

                <template v-if="item.objType === 45">{{
                  item.additionalData.score
                }}</template>

                <template
                  v-else-if="
                    item.objType === 3 ||
                    item.objType === 9 ||
                    item.objType === 0 ||
                    item.objType === 33
                  "
                ></template>
                <template v-else>{{ item.handlerName }}</template> -->
              </p>
              <!--                            <p class="text">{{typeData[item.objType]}}</p>-->
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$lange == 'en' ? 'Attachment' : '附件库'"
        name="file"
      >
        <!-- <div class="fee-file">
          <div class="file-lists">
            <div class="list" v-for="(item, index) in fileData">
              <div class="top flex-between">
                <div class="lef-title">
                  {{
                    $lange == "en"
                      ? "Payment certificate / signature "
                      : "付款证明 / 签字单 "
                  }}
                </div>
                <div class="file-upload">
 
                  <div class="upload-box">
                    <cc-uploader
                      :config="uploaderConf2"
                      uploadType="dottedLine"
                      :useSuccess="true"
                      @upload-success="uploadSuccess($event, index)"
                    />
                  </div>
                  <div class="file-box">
                    <template
                      v-for="(fileItem, fileIdx) in item.accessoryInfoList"
                    >

                      <div
                        class="file-item"
                        @click="downloadFile(fileItem, fileItem.fileName)"
                      >
                        <span
                          v-if="iconFilter(fileItem)"
                          class="icon el-icon-picture-outline"
                        ></span>
                        <span v-else class="icon el-icon-tickets"></span>
                        {{ fileItem.fileName }}
                        <span
                          class="icon el-icon-delete"
                          style="color: #f56c6c; margin-left: 40px"
                          @click.stop="delFile(fileIdx, index)"
                        ></span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="fee-type">
                <span class="lef-title">{{
                  $lange == "en" ? "Mark payment status" : "标记付款状态"
                }}</span>
                <span class="fee-select">
                  <template v-if="item.status === 0 && isHandle == true">
                    <el-select
                      size="mini"
                      v-model="item.payStatus"
                      placeholder="标记付款状态"
                    >
                      <el-option
                        :label="statusItem.label"
                        :value="statusItem.value"
                        v-for="(statusItem, statusIndex) in statusArr"
                      ></el-option>

                    </el-select>
                  </template>
                  <template v-else>
                    <span style="color: #bbb">{{
                      statusArr[item.payStatus].label
                    }}</span>
                  </template>
                </span>
                <span>
                  <el-button
                    type="text"
                    @click="saveType(item)"
                    v-if="item.status === 0 && isHandle == true"
                    >{{ $lange == "en" ? "Save" : "保存" }}</el-button
                  >
                </span>
              </div>
              <div class="fee-type">
                <span class="lef-title">{{
                  $lange == "en" ? "Customer remark" : "客户备注"
                }}</span>
                <span class="fee-select" style="color: #bbb">{{
                  item.remark || "暂无备注"
                }}</span>
                <div
                  style="margin-top: 35px; margin-left: 140px"
                  v-if="item.status === 0 && isHandle == true"
                >
                  <p></p>
                  <el-button
                    style="font-size: 16px"
                    type="primary"
                    size="mini"
                    @click="schemeConfirm(item, index)"
                    >{{
                      $lange == "en"
                        ? "Generate dispatch service list / parts list"
                        : "生成外派服务单/配件订单"
                    }}</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <template v-if=" activeName == 'file'">
          <OrderFile :orderId="orderId"></OrderFile>
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="back-btn" @click="backBtn" v-if="showClose == 1">
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-circle-close"
      ></el-button>
    </div>
    <el-dialog
      :visible.sync="showBigImage"
      width="60%"
      class="partsForm"
      append-to-body
    >
      <img
        :src="nowShowImageUrl"
        style="width: 100%; display: block; margin: 0 auto"
        alt
      />
    </el-dialog>
  </div>
</template>

<script>
import OrderComponent from "./components/OrderComponent";
import OrderComponentV2 from "./components/OrderComponentV2";
import OrderFile from "./components/orderFile";
import moment from "moment";
import axios from "axios";
export default {
  name: "OrderDescription",
  components: {
    OrderComponent,
    OrderComponentV2,
    OrderFile,
  },
  props: {
    orderIdV2: String,
    // isHandleV2: Boolean,
    isDialog: Boolean,
  },
  data() {
    return {
      isImageArr: ["png", "jpeg", "jpg"],
      showOrderFlag: true,
      showMsgArr: [0], //处理记录展示特殊的字段的objType集合
      uploaderConf2: this.$uploadUtils.config,
      statusArr: [
        {
          value: 0,
          label: "待核实",
        },
        {
          value: 1,
          label: "已付款",
        },
        {
          value: 2,
          label: "未付款",
        },
      ],
      showBigImage: false,
      // isHandle: false,
      nowShowImageUrl: "",
      orderId: "",
      recordData: [],
      activeName: "description",
      typeData: {
        0: "",
        3: "工程师: ",
        6: "转移到工程师: ",
        9: "配件专员: ",
        12: "客户已同意服务",
        15: "客户已上传付款附件",
        18: "工程师: ",
        19: "配件订单安排",
        20: "",
        21: "配件已开始发货",
        24: "客户 已确认收货", //:
        27: "工程师处理中", //:
        30: "已指派外派人员", //:
        33: "外派人员已通过人员审核",
        36: "客户已收到外派通知",
        39: "上传完毕外派服务单",
        42: "工单已结束",
        45: "评价",
      },
      userData: {
        0: "创建工单",
        3: "回复",
        6: "转移到工程师: ",
        9: "审核",
        12: "客户已同意服务",
        15: "客户已上传付款附件",
        18: "审核附件人员:  ",
        19: "配件订单安排中",
        20: "",
        21: "配件已开始发货",
        24: "客户 已确认收货", //:
        27: "工程师处理中", //:
        30: "已指派外派人员", //:
        33: "外派人员已通过人员审核",
        36: "客户已收到外派通知",
        39: "上传完毕外派服务单",
        40: "客户取消服务",
        42: "工单已结束",
        45: "评价",
      },
      moment: moment,
      orderData: {
        customer: {
          customerName: "",
        },
      },
      fileData: [],
      disposeStatus: {
        0: "申请中",
        1: "处理中",
        2: "观察中",
        3: "已完成",
        4: "已关闭",
        5: "已取消",
      },
      isHandleV2: false,
      showClose: 0,
    };
  },

  methods: {
    delFile(idx, pIdx) {
      this.fileData[pIdx].accessoryInfoList.splice(idx, 1);
    },
    downloadFile(data, name) {
      if (data.fileName.indexOf("pdf") > -1) {
        let pData = {
          url: data.accessoryUrl,
        };
        return this.ccRequest
          .do("admin/fsb/file/aliyun/privateDownloadUrl", pData, "GET")
          .then((res) => {
            axios({
              method: "get",
              url: res.url,
              headers: {
                "Content-Disposition": "attachment",
              },
            }).then((res2) => {
              this.$message({
                type: "success",
                message: "文件已下载",
              });
            });
          });
      }

      this.$message({
        type: "success",
        message: "文件已下载",
      });
      let imageType = ["png", "jpg", "jpeg"];
      for (let i in imageType) {
        if (data.fileName.indexOf(imageType[i]) > -1) {
          this.downloadImage(data.accessoryUrl, name);
          return false;
        }
      }

      let a = document.createElement("a");
      a.href = data.accessoryUrl;
      a.download = name;
      a.click();
    },
    downloadImage(imgsrc, name) {
      // 下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },

    // 这里是作为判断 上传的是不是图片
    iconFilter(item) {
      let suffix = item.fileName.split(".")[1];
      if (this.isImageArr.indexOf(suffix) > -1) {
        return true;
      }
      return false;
    },
    uploadSuccess(res, index) {
      this.fileData[index].accessoryInfoList.push({
        accessoryUrl: res.accessoryUrl,
        fileName: res.fileName,
        objType: "workOrderPay",
        objId: this.orderData.schemeId,
      });
    },
    schemeConfirm(item, index) {
      this.$confirm("确认方案生成配件订单或者外派服务单, 是否确认?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // console.log(item)
        let data = {
          workOrderSchemeId: item.workOrderSchemeId,
          accessoryInfoList: this.fileData[index].accessoryInfoList,
        };
        this.showOrderFlag = false;

        this.ccRequest
          .do("admin/fsb/scheme/schemeConfirm", data, "POSTJSON")
          .then((res) => {
            // this.showOrderFlag = true;
            // item.status = 1;
            // 客户需求更改: 在提交完验收报告后, 会变更处理人, 导致出现错误的报错。。。所以直接跳转回工单首页
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.$router.push({
              path: "/admin/order/list",
              query: {},
            });
          })
          .catch((res) => {
            this.$message({
              type: "error",
              message: res.response.data.message,
            });
            this.showOrderFlag = true;
          });
      });
    },
    backBtn() {
      this.$router.push({
        name: "OrderList",
      });
    },
    changeActiveName(name) {
      this.activeName = name;
    },
    saveType(item) {
      let data = {
        id: item.workOrderSchemeId,
        payStatus: item.payStatus,
      };
      this.$confirm("确定保存吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.ccRequest
          .do("admin/fsb/scheme/save", data, "POSTJSON")
          .then((res) => {
            this.$message({
              type: "success",
              message: "保存成功",
            });
          });
      });
    },
    showImage(item) {
      this.showBigImage = true;
      this.nowShowImageUrl = item.accessoryUrl;
    },
    getRecord() {
      let data = {
        workOrderId: this.orderId,
        dataType: 0,
      };
      this.ccRequest
        .do("admin/fsb/work/order/node/query", data, "GET")
        .then((res) => {
          var recordData = [];
          for (var i = 0; i < res.rows.length; i++) {
            recordData.push(res.rows[(res.rows.length)-i-1]);
          }
          this.recordData = recordData;
        });
    },
    getFile() {
      let data = {
        workOrderId: this.orderId,
      };
      this.ccRequest
        .do("admin/fsb/work/order/queryPayingAccessory", data, "GET")
        .then((res) => {
          this.fileData = res;
        });
    },
    getWorkOrder() {
      let data = {
        id: this.orderId,
      };
      this.ccRequest.do("admin/fsb/work/order/get", data, "GET").then((res) => {
        this.orderData = res;
        this.isHandleV2 = res.isHandle;
      });
    },
    activeNameChange(e) {
      this.getRecord();
    },
    //日誌
    logText(item) {
      let text = {
        0: "创建工单",
        3: "回复",
        6: "转移到工程师: ",
        9: "审核",
        12: "客户已同意服务",
        15: "客户已上传付款附件",
        18: "审核附件人员:  ",
        19: "配件订单安排中",
        20: "",
        21: "配件已开始发货",
        24: "客户 已确认收货", //:
        27: "工程师处理中", //:
        30: "已指派外派人员", //:
        33: "外派人员已通过人员审核",
        36: "客户已收到外派通知",
        39: "上传完毕外派服务单",
        40: "客户取消服务",
        42: "工单已结束",
        45: "评价",

        //新的
        49: "创建请求 （申请中）",
        50: "开始处理",
        51: "创建配件",
        52: "修改方案",
        55: "创建外派",
        53: "观察中",
        54: "转移请求",
        60: "提交方案",
        70: "请求完成",
        75: "客户确认问题未解决，补充问题",
        80: "问题确认解决",
        85: "待评价",
        86: "已评价",
        90: "请求关闭",
        100: "取消请求",
      };

      if (item.isNewData == 0) {
        //旧逻辑
        if (item.objType == 0) {
          return `${item.additionalData.userName} ${text[item.objType]}`;
        } else if (item.objType === 3 || item.objType === 9) {
          return `${item.handlerName} ${text[item.objType]}`;
        } else if (item.objType === 45) {
          return `${text[item.objType]} ${item.additionalData.score} ${
            item.handlerName
          }`;
        } else {
          return `${text[item.objType]} ${item.handlerName}`;
        }
      } else {
        //新逻辑
        if (item.objType == 49) {
          return `${item.handlerName} ${text[item.objType]} `;
        } else if (item.objType == 50) {
          return `${item.handlerName} 开始处理 ${this.statusText(item)}`;
        } else if (item.objType == 54) {
          if (item.extraData.oldHandler && item.extraData.newHandler) {
            return `${item.extraData.oldHandler} 转发给 ${
              item.extraData.newHandler
            }  ${this.statusText(item)}`;
          } else {
            return `${item.handlerName} 转发 ${this.statusText(item)}`;
          }
        } else if (item.objType == 55) {
          return `${item.handlerName} 创建外派工单 ${this.statusText(item)}`;
        } else if (item.objType == 51) {
          return `${item.handlerName} 创建配件工单 ${this.statusText(item)}`;
        } else if (item.objType == 52) {
          return `${item.handlerName} 修改方案 ${this.statusText(item)}`;
        } else if (item.objType == 60) {
          return `${item.handlerName} 提交方案 ${this.statusText(item)}`;
        } else if (item.objType == 75) {
          return `${item.handlerName} 客户补充资料 ${this.statusText(item)}`;
        } else if (item.objType == 53) {
          return `${item.handlerName} 观察中 ${this.statusText(item)}`;
        } else if (item.objType == 70) {
          return `${item.handlerName} 完成请求 ${this.statusText(item)}`;
        } else if (item.objType == 80) {
          return `客户确认问题已解决 ${this.statusText(item)}`;
        }else if (item.objType == 85) {
          return `待客户评价 ${this.statusText(item)}`;
        } else if (item.objType == 86) {
          return `客户完成评价 ${this.statusText(item)}`;
        } else if (item.objType == 90) {
          return `${item.handlerName} 请求关闭 ${this.statusText(item)}`;
        } else if (item.objType == 100) {
          return `${item.handlerName} 取消请求 ${this.statusText(item)}`;
        }
      }
    },
    statusText(item) {
      if (item.extraData) {
        if (item.extraData.old != item.extraData.new) {
          if (
            item.extraData.new !== undefined &&
            item.extraData.old !== undefined
          ) {
            return `(由${this.disposeStatus[item.extraData.old]} 变更为 ${
              this.disposeStatus[item.extraData.new]
            } )`;
          } else {
            return `(${this.disposeStatus[item.extraData.old]})`;
          }
        } else {
          return `(${this.disposeStatus[item.extraData.old]})`;
        }
      }
      return ""
    },
  },
  mounted() {
    if (!this.isDialog) {
      this.orderId = this.$route.query.id;
      // if (this.$route.query.isHandle) {
      //   this.isHandle = true;
      // }
    } else {
      this.orderId = this.orderIdV2;
      // if (this.isHandleV2) {
      //   this.isHandle = this.isHandleV2;
      // }
    }
    if (this.$route.query.showClose) {
      this.showClose = this.$route.query.showClose;
    }
    this.getRecord();
    // this.getFile();
    this.getWorkOrder();
  },
};
</script>
<style>
.el-tabs__content {
  padding: 0 !important;
}
</style>
<style scoped lang="scss">
.el-tabs--border-card {
  // background: transparent;
  // box-shadow: none;
  // border: none;
}
.machine {
  background: #fff;
  padding: 20px;
  .input-box {
    margin-right: 20px;
  }
  .search-group {
    display: flex;
    margin-bottom: 20px;
  }
}
.cost {
  background: #fff;
  padding: 20px;
  .title {
    margin-bottom: 20px;
  }
}
.record-lists {
  position: relative;
  background: #ffffff;
  padding: 20px;
  .center-border {
    position: absolute;
    width: 1px;
    height: 100%;
    background: #e4e4e4;
    left: 170px;
  }
  .list {
    margin-top: 20px;
    .left {
      width: 120px;
      text-align: right;
      margin-right: 30px;
      color: #bbb;
      .left-time {
        color: #1ab394;
        margin-top: 5px;
      }
    }
    .right {
      flex: 1;
      margin-left: 30px;
      border-bottom: 1px solid #e4e4e4;
      padding: 15px;
      padding-top: 45px;
      .user-name {
        font-size: 16px;
      }
      .text {
        margin-top: 10px;
        color: #aaa;
      }
    }
  }
}
.fee-file {
  background: #ffffff;
  padding: 20px;

  .file-lists {
    .list {
      padding-bottom: 20px;
      .lef-title {
        font-weight: bolder;
        width: 130px;
        text-align: right;
        display: inline-block;
      }
      font-size: 16px;
      &:not(:last-child) {
        margin-bottom: 20px;
        border-bottom: 1px solid #e4e4e4;
      }
      .top {
        align-items: flex-start;
        justify-content: flex-start;
        .file-upload {
          margin-left: 15px;
          justify-content: flex-start;
          .upload-box {
            position: relative;
            width: 150px;
            height: 40px;
            margin-right: 30px;
          }
          .file-box {
            margin-top: 15px;
            color: #666666;
            .file-item {
              cursor: pointer;
              text-decoration: underline;
              margin-bottom: 10px;
              &:hover {
                opacity: 0.85;
              }
              > .icon {
                margin-right: 5px;
              }
            }
          }
        }
      }
      .fee-type {
        margin-top: 10px;
        .fee-select {
          margin: 0 15px;
        }
      }
    }
  }
}
.product-description {
  padding-bottom: 100px;
}
</style>
